import { useTranslation } from 'react-i18next';
import React, {useState, useEffect,Fragment} from 'react';
import { useParams } from "react-router-dom";
import apiRequest from '../../functions/api';
import {
  Paper,
  Typography,
  Table,
  Hidden,
  TableBody,
  TableCell,
  TableContainer,
  TableRow
} from "@mui/material";
import { withStyles } from '@mui/styles';
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import { useMessage } from '../../context/message-context';
const styles = (theme) => ({
  root: {
    marginLeft: theme.spacing(9),
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
      
    },
  },
  paper: {
    margin: theme.spacing(2),
  },
  form: {
    margin: theme.spacing(1),
    flex: 1
  },
});
function TimeCorrectionDetails(props) {
  const { t } = useTranslation();
  let { date } = useParams();
  const [correction, setCorrection] = useState(null);
  const { accessToken,  client} = props;
  const [isLoading, setIsLoading] = useState(false);
  const [mazeiten, setMazeiten] =useState([]);
  const [vgzeiten, setVgzeiten] =useState([]);
  const {hideMessage, showErrorMessage} = useMessage();
  
  useEffect(() => {
    setIsLoading(true);
    const payload={
      "mandant": client,
      "program": "PZKOA0",
      "statement": "DETAILS",
      "date": date,
    }
    const headers={
      "Authorization": "Bearer "+accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, antragCb);
    // eslint-disable-next-line
  }, [])
  const antragCb = (response) => {
    if (response.status === 200) {
        setCorrection(response.data.correction);
        setMazeiten(response.data.correction.matimes)
        if (response.data.correction.vgtimes) {
          setVgzeiten(response.data.correction.vgtimes)
        }
        setIsLoading(false);
        hideMessage();
    } else {
        if (response) {
          showErrorMessage(response.data.message);
        } else {
          showErrorMessage(t("Keine Internetverbindung"));
        }
    }      
}
  
  if (isLoading) {
    return <LoadingComponent />
  }
  
  if (!correction) {
    return (
      <Typography color="primary" variant="h5">{t("Antrag konnte nicht gefunden werden")}</Typography>
    )
  }
  return (
    <div>
      <Hidden smDown>
        <Typography color="primary" variant="h5">{t("Details des Korrekturantrags")}</Typography>
      </Hidden>
      <TableContainer component={Paper}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>{t("Antrag gestellt am ")}</TableCell>
              <TableCell>{correction.datum}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>{t("Datum der Korrektur")}</TableCell>
              <TableCell>{correction.zeitraum}</TableCell>
            </TableRow>
            { correction.original.length > 0 &&
            <TableRow>
              <TableCell>{t("Orginalzeiten")}</TableCell>
              <TableCell>{correction.original}</TableCell>
            </TableRow>
            }
            {mazeiten.length > 0 && 
            <Fragment>
            <TableRow>
              <TableCell colSpan={2}>{t("Beantragte Zeiten")}</TableCell>
            </TableRow> 
            <TableRow>
              <TableCell>{t("Von")}</TableCell>
              <TableCell>{t("Bis")}</TableCell>
            </TableRow>
           { mazeiten.map((antwort,count)=> {
             return (
              <Fragment>
              <TableRow>
                <TableCell>
                  <Typography>{antwort.von}</Typography>
                </TableCell>
                <TableCell>
                <Typography>{antwort.bis}</Typography>
                </TableCell>                
              </TableRow>
              </Fragment>
             )
           })}
            </Fragment>
           }
            {vgzeiten.length > 0 && 
            <Fragment>
            <TableRow>
              <TableCell colSpan={2}>{t("Genehmigte Zeiten")}</TableCell>
            </TableRow> 
            <TableRow>
              <TableCell>{t("Von")}</TableCell>
              <TableCell>{t("Bis")}</TableCell>
            </TableRow>
           { vgzeiten.map((antwort,count)=> {
             return (
              <Fragment>
              <TableRow>
                <TableCell>
                  <Typography>{antwort.von}</Typography>
                </TableCell>
                <TableCell>
                <Typography>{antwort.bis}</Typography>
                </TableCell>                
              </TableRow>
              </Fragment>
             )
           })}
            </Fragment>
           }           
            { correction.macomment !=="" &&
              <TableRow>
                <TableCell>{t("Bemerkung (Antragsteller)")}</TableCell>
                <TableCell> {correction.macomment} </TableCell>
              </TableRow>
            }
            { correction.vgcomment !=="" &&
              <TableRow>
                <TableCell>{t("Bemerkung (Vorgesetzter)")}</TableCell>
                <TableCell> {correction.vgcomment} </TableCell>
              </TableRow>
            }
         </TableBody>
      </Table>
    </TableContainer>
  </div>
  )
}
export default withStyles(styles)(TimeCorrectionDetails);
